import fetchPlus from "../lib/fetchPlus/fetchPlus";
import { ApiResponse } from "../types/API/ApiResponse";
import Count from "../types/API/whatsNew/Count";

const whatsNewService = {
    // Fetch to ge the number of files inside src/data folder.
    GET_WHATS_NEW_COUNT_SWR_KEY: "/whats-new/count",
    getWhatsNewCount: () => fetchPlus<ApiResponse<"data", Count>>(`${process.env.NEXT_PUBLIC_INTERNAL_API_URL}/whats-new/count`, "GET"),
};

export default whatsNewService;
